module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mt-0c23ea353ac917d9e4d486a9af72e221.svg";